<template>
    <div>
    <div class="title--area">
      <h2>{{ menuNm }}</h2>
    </div>
    <div class="data--container" v-resize @resize="onResize">
      <div class="flex--box flex--box--1_2 btn--on" style="width:50%;">
        <div class="btn--area space--between">
          <button type="button" class="btn btn--black" @click="addSido">추가</button>
          <div class="btns">
            <button type="button" class="btn btn--white" @click="saveSido">저장</button>
            <button type="button" class="btn btn--white" @click="delSido">삭제</button>
          </div>
        </div>
        <div class="grid--area">
          <grid ref="grid1"
              :data="gridSidoProps.data"
              :columns="gridSidoProps.columns"
              :options="gridSidoProps.options"
              :language="'ko'"
              @click="gridClick"
              @check="gridCheck">
          </grid>
        </div>
      </div>
      <div class="flex--box flex--box--1_2 btn--on flex--box--black" style="width:50%;">
        <div class="btn--area space--between">
          <button type="button" class="btn btn--black" @click="addSigungu">추가</button>
          <div class="btns">
            <button type="button" class="btn btn--white" @click="saveSigungu">저장</button>
            <button type="button" class="btn btn--white" @click="delSigungu">삭제</button>
            <button type="button" class="btn btn--white" @click="excelDownload">엑셀다운로드</button>
            <button type="button" style="position: relative; z-index: 2; pointer-events: none;" class="btn btn--white" @change="excelUpload" @click="excelUpload">엑셀업로드</button>
              <input type="file" style=" position: absolute; right:32px; z-index: 1;" class="btn btn--white" @change="excelUpload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
          </div>
        </div>
        <input type="hidden" name="saveFlg" id="saveFlg" value="N"/>
        <div class="grid--area">
          <grid ref="grid2"
              :data="gridSigunguProps.data"
              :columns="gridSigunguProps.columns"
              :options="gridSigunguProps.options"
              :language="'ko'"
              @check="gridCheck">
          </grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from '@toast-ui/vue-grid'
import mapCodeMngApi from '@/api/admin/MapCodeMng.js'
import $ from 'jquery'
import * as XLSX from 'xlsx'

export default {
  name: 'MapCodeMng',
  components: {
    grid: Grid
  },

  data () {
    return {
      menuNm: this.$route.name,
      excel: [],
      searchText: '',
      gridSidoProps: {
        data: [],
        columns: [
          {
            header: '시도코드',
            name: 'sidoId',
            width: 180,
            align: 'center',
            editor: 'text',
            validation: {
              required: true,
              unique: true // 중복값
            }
          },
          {
            header: '시도코드명',
            name: 'siNm',
            width: 80,
            align: 'center',
            editor: 'text'
          },
          {
            header: '단축명',
            name: 'siShtNm',
            width: 150,
            align: 'center',
            editor: 'text'
          },
          {
            header: '사용여부',
            name: 'useFlg',
            align: 'center',
            width: 120,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '시도코드',
            name: 'sido_id',
            width: 120,
            align: 'center',
            editor: 'text'
          }
        ],
        options: {
          rowHeaders: ['checkbox'],
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 580,
          selectionUnit: 'cell',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick'
        }
      },
      gridSigunguProps: {
        data: [],
        columns: [
          {
            header: '시도코드',
            name: 'sidoId',
            width: 90,
            align: 'center',
            editor: 'text'
          },
          {
            header: '시도코드명',
            name: 'siNm',
            width: 120,
            align: 'center',
            editor: 'text',
            sortable: true
          },
          {
            header: '시군구코드',
            name: 'sigunguId',
            width: 180,
            align: 'center',
            editor: 'text',
            filter: { type: 'text', showApplyBtn: true, showClearBtn: true },
            validation: {
              unique: true,
              required: true
            }
          },
          {
            header: '시군구코드명',
            name: 'sigunguNm',
            width: 180,
            align: 'center',
            editor: 'text',
            filter: { type: 'text', showApplyBtn: true, showClearBtn: true },
            validation: {
              unique: true,
              required: true
            }
          },
          {
            header: '단축명',
            name: 'sigunguShtNm',
            align: 'center',
            width: 180,
            editor: 'text',
            validation: {
              unique: true
            }
          },
          {
            header: '사용여부',
            name: 'useFlg',
            width: 80,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          }
        ],

        options: {
          rowHeaders: ['checkbox'],
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 580,
          selectionUnit: 'row',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick'
        }
      },
      rowKey: null,
      mapSysNo: '',
      sidoId: '',
      sidoNm: '',
      attribute: {
        expanded: true
      }
    }
  },
  mounted () {

  },
  created () {
    this.searchGridSidoData() // 상위 그리드 조회
  },
  methods: {
    onResize () {
      this.$refs.grid1.invoke('refreshLayout')
      this.$refs.grid2.invoke('refreshLayout')
    },
    // 상위 트리 그리드 조회
    async searchGridSidoData () {
      const params = {}
      const mapSidoMngData = await mapCodeMngApi.mapSidoMngList(params)
      this.gridSidoProps.data = mapSidoMngData

      if (this.gridSidoProps.data !== undefined) {
        this.$refs.grid1.invoke('resetData', this.gridSidoProps.data)
      }
    },

    // 왼쪽 그리드 클릭 시 오른쪽 그리드 조회하기
    gridClick (ev) {
      if (ev.targetType === 'cell') {
        this.rowKey = ev.rowKey
        this.mapSysNo = this.$refs.grid1.invoke('getValue', ev.rowKey, 'mapSysNo')
        this.sidoId = this.$refs.grid1.invoke('getValue', ev.rowKey, 'sidoId')
        this.siNm = this.$refs.grid1.invoke('getValue', ev.rowKey, 'siNm')

        if (this.sidoId !== null) { // 시도코드가 있을때 하위 그리드 조회
          this.searchGridSigunguData()
          this.setSaveFlg('N')
        }
      }
    },

    // 하위 그리드 조회
    async searchGridSigunguData (excelSidoId) {
      let params

      if (excelSidoId !== undefined) { // 엑셀 시도코드가 있다면
        params = { sidoId: excelSidoId } // sidoId 에 엑셀의 시도코드 넣어주기
      } else {
        params = { sidoId: this.sidoId }
      }

      const mapSigunguMngData = await mapCodeMngApi.mapSigunguMngList(params)

      this.gridSigunguProps.data = mapSigunguMngData
      this.$refs.grid2.invoke('resetData', this.gridSigunguProps.data)
    },

    gridRequiredCheck () { // 필수 입력값 체크
      const rowCnt = this.$refs.grid1.invoke('getRowCount')
      for (let i = 0; i < rowCnt; i++) {
        const sidoId = this.$refs.grid1.invoke('getRowAt', i).sidoId
        if (sidoId == null || sidoId === '') {
          alert('시도코드를 입력해주세요!')
          this.$refs.grid1.invoke('focus', i, 'sidoId')
          return false
        }
      }

      return true
    },

    addSido () {
      this.$refs.grid1.invoke('appendRow', { sidoId: null, useFlg: 'Y' }, { focus: true })
    },

    async saveSido () {
      if (!this.gridRequiredCheck()) return // 필수항목 값 체크
      const params = this.$refs.grid1.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows
      if (params.createdRows.length === 0 && params.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면 이벤트 발생없이 return
        return
      }

      if (this.$refs.grid1.invoke('validate').length > 0) { // 중복 값 체크
        if (this.$refs.grid1.invoke('validate')[0].errors[0].errorCode[0] === 'UNIQUE') {
          alert('중복된 값을 확인해주세요!')
          return
        }
      }

      if (window.confirm('저장하시겠습니까?')) {
        const params = this.$refs.grid1.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows
        const result = await mapCodeMngApi.saveMapSido(params)

        if (result.result) {
          alert('저장되었습니다.')
          this.searchGridSidoData()
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      }
    },

    // 시군구 하위 그리드 row 추가
    addSigungu () {
      if (this.rowKey == null) {
        alert('목록을 선택해주세요.')
      } else {
        this.$refs.grid2.invoke('appendRow', { sidoId: this.sidoId, siNm: this.siNm, useFlg: 'Y' }, { focus: true })
      }
    },

    async saveSigungu () {
      var saveFlg = $('#saveFlg').val()
      const params = []
      const rowCnt = this.$refs.grid2.invoke('getRowCount')

      if (saveFlg === 'N') { // saveFlg 가 N이라면
        if (!this.gridRequiredChecks()) return // 필수항목 값 체크
        const params = this.$refs.grid2.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows
        if (params.createdRows.length === 0 && params.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면 이벤트 발생없이 return
          return
        }

        if (this.$refs.grid2.invoke('validate').length > 0) { // 중복 값 체크
          if (this.$refs.grid2.invoke('validate')[0].errors[0].errorCode[0] === 'UNIQUE') {
            alert('중복된 값을 확인해주세요!')
            return
          }
        }

        if (window.confirm('저장하시겠습니까?')) {
          const params = this.$refs.grid2.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows
          const result = await mapCodeMngApi.saveMapSigungu(params)

          if (result.result) {
            alert('저장되었습니다.')
            this.searchGridSigunguData()
            this.setSaveFlg('N')
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else { // saveFlg 가 Y라면 (엑셀이 업로드 되었다면)
        if (window.confirm('저장하시겠습니까?')) {
          for (let i = 0; i < rowCnt; i++) { // 그리드2의 row갯수만큼 for문
            params.push(this.$refs.grid2.invoke('getRowAt', i))
          }
          const result = await mapCodeMngApi.insertMapSigungu(params)

          if (result.result) {
            alert('저장되었습니다.')
            this.searchGridSigunguData()
            this.setSaveFlg('N')
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      }
    },

    gridRequiredChecks () { // 필수 입력값 체크
      const rowCnt = this.$refs.grid2.invoke('getRowCount')
      for (let i = 0; i < rowCnt; i++) {
        const sigunguId = this.$refs.grid2.invoke('getRowAt', i).sigunguId
        const sigunguNm = this.$refs.grid2.invoke('getRowAt', i).sigunguNm
        if (sigunguId == null || sigunguId === '') {
          alert('시군구코드를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'sigunguId')
          return false
        } else if (sigunguNm == null || sigunguNm === '') {
          alert('시군구코드명을 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'sigunguNm')
          return false
        }
      }

      return true
    },

    // 하위 그리드 체크박스 선택 이벤트
    gridCheck (ev) {
      if (this.$refs.grid1.invoke('getValue', ev.rowKey, 'sido_id') == null) {
        this.$refs.grid1.invoke('removeRow', ev.rowKey)
      } else if (this.$refs.grid2.invoke('getValue', ev.rowKey, 'sigunguNm') == null) {
        this.$refs.grid2.invoke('removeRow', ev.rowKey)
      }
    },

    // 시도 그리드 내 삭제 event
    async delSido () {
      const params = this.$refs.grid1.invoke('getCheckedRows') // check 된 row만 삭제

      if (params.length > 0) {
        if (window.confirm('삭제하시겠습니까?')) {
          const result = await mapCodeMngApi.deleteMapSido(params)

          if (result.result) {
            alert('삭제되었습니다.')
            this.searchGridSidoData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else {
        alert('삭제하실 항목을 선택해주세요.')
      }
    },

    // 시군구 그리드 삭제 event
    async delSigungu () {
      const params = this.$refs.grid2.invoke('getCheckedRows') // check 된 row만 삭제

      if (params.length > 0) {
        if (window.confirm('삭제하시겠습니까?')) {
          const result = await mapCodeMngApi.deleteMapSigungu(params)

          if (result.result) {
            alert('삭제되었습니다.')
            this.searchGridSigunguData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else {
        alert('삭제하실 항목을 선택해주세요.')
      }
    },

    // 엑셀 업로드
    async excelUpload (ev) {
      const file = ev.target.files[0]
      let tmpResult = {}
      const reader = new FileReader()

      reader.onload = () => {
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          wb.Sheets[sheetName].A1.w = 'sidoId'
          wb.Sheets[sheetName].B1.w = 'siNm'
          wb.Sheets[sheetName].C1.w = 'sigunguId'
          wb.Sheets[sheetName].D1.w = 'sigunguNm'
          wb.Sheets[sheetName].E1.w = 'sigunguShtNm'
          wb.Sheets[sheetName].F1.w = 'useFlg'

          const roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          tmpResult = roa
        })
      }

      reader.readAsBinaryString(file)
      reader.onloadend = async () => {
        this.$refs.grid2.invoke('resetData', tmpResult)
        this.setSaveFlg('Y')
      }
    },

    excelDownload () {
      this.$refs.grid2.invoke('export', 'xlsx', { fileName: '지역코드관리' })
    },

    setSaveFlg (val) { // 엑셀업로드 플래그
      $('#saveFlg').val(val)
    }
  }
}

</script>

<style>
</style>
